<ecp-ucl-snackbar style="width: 80vw" [placement]="oConfig.placement" [dismissible]="true" [timeout]="8000" [variant]="oConfig.variant"
    [contentAlignment]="oConfig.contentAlignment" [elevation]="oConfig.elevation" [contrast]="oConfig.contrast"
    [state]="oConfig.state" [snackbar-width]="'700px'" #snackbar>
  <ecp-ucl-snackbar-content>{{oConfig.message}}</ecp-ucl-snackbar-content>
</ecp-ucl-snackbar>
